import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';

const Home = () => {
  return (
    <div>
      {/* Hero Section */}
      <section
        className="hero-section"
        style={{
          backgroundImage: 'url(/asset/b2b1.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          color: '#fff',
          padding: '150px 0'
        }}
      >
        <Container>
          <Row>
            <Col md={8}>
              <h1>Platforma B2B de Schimburi Comerciale</h1>
              <p style={{ fontSize: '1.2rem' }}>
                Descoperă un mod inovator de a face afaceri. Platforma noastră conectează companii
                pentru schimburi business-to-business, integrând seamless cu SmartBill și eMag.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Features Section */}
      <section id="features" style={{ padding: '80px 0', backgroundColor: '#f9f9f9' }}>
        <Container>
          <Row className="mb-5">
            <Col>
              <h2 className="text-center">Caracteristici Cheie</h2>
              <p className="text-center">
                O platformă completă pentru schimburi comerciale între companii, cu integrare
                modernă și funcționalități avansate.
              </p>
            </Col>
          </Row>
          <Row>
            <Col md={4} className="text-center mb-4">
              <img
                src="/asset/b2b2.jpg"
                alt="Schimburi B2B"
                className="img-fluid mb-3"
                style={{ height: '300px', objectFit: 'cover' }}
              />
              <h4>Schimburi B2B</h4>
              <p>
                Conectează-te cu partenerii de afaceri și explorează noi oportunități de colaborare.
              </p>
            </Col>
            <Col md={4} className="text-center mb-4">
              <img
                src="/asset/b2b3.jpg"
                alt="Integrare SmartBill"
                className="img-fluid mb-3"
                style={{ height: '300px', objectFit: 'cover' }}
              />
              <h4>Integrare SmartBill</h4>
              <p>
                Gestionează facturarea și operațiunile financiare cu integrare seamless în SmartBill.
              </p>
            </Col>
            <Col md={4} className="text-center mb-4">
              <img
                src="/asset/b2b4.jpg"
                alt="Integrare eMag"
                className="img-fluid mb-3"
                style={{ height: '300px', objectFit: 'cover' }}
              />
              <h4>Integrare eMag</h4>
              <p>
                Accesează un marketplace de top și extinde-ți piața prin integrarea cu eMag.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Call-to-Action Section */}
      <section style={{ padding: '60px 0', backgroundColor: '#fff' }}>
        <Container className="text-center">
          <h2>Începe Să-ți Crești Afacerea Astăzi</h2>
          <p>
            Fă parte din revoluția comerțului între companii! Înregistrează-te și profită de toate
            avantajele noastre.
          </p>
          <Button variant="primary" size="lg">Înregistrează-te</Button>
        </Container>
      </section>
    </div>
  );
};

export default Home;